import React from 'react';

const DataGrid = ({ data }) => {
  if (!data || data.length === 0) {
    return <p>Nenhum dado disponível.</p>;
  }

  const columns = Object.keys(data[0]);

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col} style={{ border: '1px solid #ccc', padding: '8px', background: '#f9f9f9' }}>
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, idx) => (
          <tr key={idx}>
            {columns.map((col) => (
              <td key={col} style={{ border: '1px solid #ccc', padding: '8px' }}>
                {row[col]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DataGrid;
